"use client";

import { useI18n } from "@wojo/localization";
import { ZendeskArticle } from "@wojo/storyblok";
import { Text } from "@wojo/ui";
import { notFound } from "next/navigation";
import { useMyTripForBookingId } from "@myaccount/_client/hooks";
import { AccountPushToAppCard } from "./AccountPushToAppCard";
import styles from "./AccountPushToAppPage.module.scss";
import { getPushToAppCardCopy } from "./get-push-to-app-copy";
import { ValidMvpSlug } from "./use-valid-push-to-app-slug";
import { useId } from "react";

export type AccountPushToAppProps = {
    slug: ValidMvpSlug;
    bookingId: string;
};

export const AccountPushToAppPage: React.FC<AccountPushToAppProps> = ({
    bookingId,
    slug,
}) => {
    const mvpCopyDict = useI18n("account").account.mvpPages.pages;
    const trip = useMyTripForBookingId(bookingId);
    const zendeskHeadingId = useId();

    if (!trip?.departure?.tourCode) {
        return notFound();
    }

    const baseL10n = mvpCopyDict[slug] ?? null;
    const cardCopy = getPushToAppCardCopy(slug, trip, baseL10n);

    if (!cardCopy) {
        return null;
    }

    return (
        <div className={styles["content-group"]}>
            <AccountPushToAppCard
                content={cardCopy}
                tourCode={trip.departure.tourCode}
            />
            {cardCopy.zendeskHeader &&
                cardCopy.zendeskQuery &&
                process.env.NEXT_PUBLIC_ZENDESK_HELP_CENTER_URL && (
                    <section aria-labelledby={zendeskHeadingId}>
                        <Text.Heading
                            order="3"
                            tag="h2"
                            className={styles["zendesk-title"]}
                            id={zendeskHeadingId}
                        >
                            {cardCopy.zendeskHeader}
                        </Text.Heading>
                        <ZendeskArticle
                            zendeskCategoryQuery={cardCopy.zendeskQuery}
                            hideCategoryName={false}
                            disableContainerPadding={true}
                            numberOfArticles="10"
                            layout="2"
                            action={[]}
                        />
                    </section>
                )}
        </div>
    );
};
